import React from "react";
import { useNavigate } from "react-router";

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="z-50 w-full text-white text-bold">
      <div className="container mx-auto text-center">
        <span>
          &copy; {new Date().getFullYear()} Sparetime Travel. All rights reserved.
        </span>
        <span className="mx-2">|</span>
        <button
          id="footer-about-button"
          className="underline text-white hover:text-gray-300 mx-1"
          type="button"
          onClick={() => navigate("/about")}
        >
          About
        </button>
        <span className="mx-1">|</span>
        <button
          id="footer-privacy-button"
          className="underline text-white hover:text-gray-300 mx-1"
          type="button"
          onClick={() => navigate("/privacy")}
        >
          Data Privacy
        </button>
      </div>
    </footer>
  );
};

export default Footer;
